module.exports = __webpack_public_path__ + "fonts/TTFirs-Medium.63918089.eot";